export const MIN_ITEMS_COUNT_FOR_SHOW_MORE = 5;
export const MIN_ITEMS_COUNT_FOR_SEARCH_FIELD = 6;

export default {
    props: {
        showTitle: {
            type: Boolean,
            required: false,
            default: true,
        },
        filter: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number, Boolean, Object],
            required: true,
        },
        hasResults: {
            type: [String, Boolean],
            default: false,
        },
        forceShowAll: { // See enum
            type: Boolean,
            default: true,
        },
        isShort: { // Short version of the filters, like popup in the enum filter
            type: Boolean,
            default: false,
        },
        symbol: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            localSearch: '',
            showMore: false,
        };
    },
    computed: {
        filterLabel() {
            const title = this.$t(`filters.byType.${this.filter.name}`);
            return title ? (title.title || title.label) || this.filter.name : this.filter.name;
        },
        filterValue() {
            return this.value;
        },
        isActiveTopFiltersPosition() {
            return this.$configuration?.layout?.filterPosition === 'top';
        },
    },
    methods: {
        onChange(value = {}) {
            this.$emit('change', { field: this.filter.name, ...value });
        },
        onFilterClick(event, params = {}) {
            const trackParams = {
                field: this.filter.name,
                ...params,
            };

            this.$emit('filter-click', { type: 'filterClick', event, paramsClick: trackParams });
        },
        transformValue(string) {
            let newString = string;

            if (this.$configuration.hasConvertStringFiltersValuesToNumber &&
                ((string && Number(string)) || Number(string) === 0)) {
                newString = Number(string);
            }

            if (newString === 'true' || newString === 'false') {
                newString = this.$t(`filters.${newString}`);
            }

            return newString;
        },
        emitChangeSize() {
            this.$nextTick(() => {
                this.$emit('change-size');
            });
        },
    },
};
